import * as types from './types';
import { UserService } from '../../services/user.service';
import { HttpClient, createHttpGetOptions } from '../../../../services/http/http-client';
import { SET_MAIN_NAV_ACTIVE, UPDATE_SYSTEM_LANGUAGE } from '../../../../store/app/types';
import { REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import { HttpLib } from '../../../../services/http/http-lib';
import router from '../../../../router';
import { setMainNavInactive } from '../../../../store/app/mutations';
import { getNavTabModule } from '../../../../dt-plugins/sidewindow/nav-tab';

let userDetailsSource;
const NavTabModule = getNavTabModule(types.UserDetails, 'userDetails');
const user_idr = () => router.currentRoute.params.user_id;

export const userActions = {
  ...NavTabModule.implementActions(
    'user_id',
    'users/user_id/tab',
    'users',
    () => router,
    'settings',
    (value, key) => {
      return {
        title: value?.usr?.user_name ?? key,
        full_title: value?.usr?.user_name ?? key,
      }
    }
  ),
  // Show Sidewindow
  async [types.UserDetails.FETCH.SINGLE]({ commit, getters, dispatch }, payload) {
    const NavTabHelper = NavTabModule.Helper(dispatch, getters);

    let { flag, user, reload } = payload;

    flag = typeof flag === "boolean" ? flag : true;

    setMainNavInactive(commit, flag);

    const primaryKey = "user_id";
    const itemName = "user";
    const item = payload[itemName];

    if (!item) {
    return;
    }

    const primaryKeyValue = item[primaryKey];
    const detailsGetterKey = "userDetails";
    const DetailsAction = types.UserDetails;

    // Check Reload and prexisting Item Logic
    if (getters?.[detailsGetterKey]?.[primaryKeyValue] && !reload) {
      return;
    }
    
    NavTabHelper.setSingleNavTabDetails(primaryKeyValue, () => {
      return {
          [itemName]: item,
          loading: true
      };
    });

    // HTTP Req
    const userModule = await UserService.findUserModules({
      user_id: primaryKeyValue
    });
    const userSetup = await UserService.findUserSetup({
      user_id: primaryKeyValue
    });

    const detailsData = {
      ...userModule.data,
      ...userSetup.data
    };

    // console.log('userDetails:mdsir', detailsData);

    NavTabHelper.setSingleNavTabDetails(
    primaryKeyValue,
    (detailsDict, invoiceProject) => {
        return {
        ...invoiceProject,
        ...detailsData,
        loading: false,
        };
    });
  },
  async [types.UserDetails.UPDATE.MULTIPLE]({ dispatch, getters }, payload) {
    const { user_id, ...rest } = payload;
    const userID = user_id ?? user_idr();

    const NavTabHelper = NavTabModule.Helper(dispatch, getters);
    NavTabHelper.updateSingleNavTabDetails(userID, userDetailsObj => {
      return {
        ...userDetailsObj,
        ...rest
      };
    });
  },
  async [types.Users.FETCH.ALL]({ commit }, payload) {
    const { username, password } = payload;
    const userlistData = await UserService.findUserList({
      user_name: username,
      password: password
    }).then(res => res.data);
    if (userlistData.all_user && userlistData.all_user.length > 0) {

      commit(types.Users.SET.ALL, userlistData);
      return Promise.resolve(userlistData);
    } else {
      return Promise.reject(userlistData.status);
    }
  },

  async [types.Users.UPDATE.SINGLE]({ commit, getters, rootGetters }, payload) {
    const { name, value, item } = payload;

    const key = 'user_id';
    const kVal = item[key];
    const table = 'users';

    commit(types.Users.SET.ALL, {
      ...getters.userlist,
      all_user: getters.userlist.all_user.map(e => {
        if (e[key] == kVal) {
          return {
            ...e,
            [name]: value
          };
        } else {
          return e;
        }
      })
    });

    const updateUser = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );

  },

  async [types.SelectedUser.SET.SINGLE]({ commit }, payload) {
    const { user, flag } = payload;
    console.log('user', user)

    setMainNavInactive(commit, flag);

    if (flag) {
      const { user_id } = user;

      userDetailsSource && userDetailsSource.cancel(REQUEST_CANCELLED);
      userDetailsSource = HttpLib.CancelToken.source();

      const userModule = await UserService.findUserModules({
        user_id
      }, createHttpGetOptions({
        cancelToken: userDetailsSource.token
      }));
      const userSetup = await UserService.findUserSetup({
        user_id
      }, createHttpGetOptions({
        cancelToken: userDetailsSource.token
      }));
      console.log({
        ...userModule.data,
        ...userSetup.data
      });
      commit(types.SelectedUser.SET.SINGLE, {
        ...userModule.data,
        ...userSetup.data
      });
    }

  },

  async [types.SELECT_USER_AUTO]({ commit, getters }, payload) {
    router.push({
      name: 'users'
    });
  },
  async [types.SelectedUser.UPDATE.SINGLE]({ commit, getters, dispatch, rootGetters }, payload) {
    const { name, value } = payload;
    // const user = getters.userDetails.usr;
    const user = getters.userDetails[user_idr()]['usr'];

    const key = 'user_id';
    const kVal = user[key];
    const table = 'users';

    // commit(types.SelectedUser.SET.SINGLE, {
    //   ...getters.userDetails,
    //   usr: {
    //     ...getters.userDetails.usr,
    //     [name]: value
    //   }
    // });

    dispatch(types.UserDetails.UPDATE.MULTIPLE, {
      usr: { ...user, [name]: value }
    });

    const findUser = getters.userlist.all_user.find(e => e.user_id == kVal);

    console.log(findUser);

    if (findUser) {
      commit(types.Users.SET.ALL, {
        ...getters.userlist,
        all_user: getters.userlist.all_user.map(e => {
          if (e[key] == kVal) {
            return {
              ...e,
              [name]: value
            };
          } else {
            return e;
          }
        })
      });
    }

    // Update the Language of the User--- If the User Sidewindow is the Logged in User

    // console.log({ "User is Same as Logged In ? ": name, kVal, us: rootGetters.account.user.user_id });
    if (name == 'language' && kVal == rootGetters.account.user.user_id) {
      dispatch(UPDATE_SYSTEM_LANGUAGE, rootGetters.systemLanguagesTV.find(e => e.value == value), { root: true });
    }


    const updateUser = await HttpClient.modify(
      key,
      kVal,
      name,
      value,
      table
    );

  },
  async [types.HIDE_USER_MODULE]({ commit, getters, dispatch }, payload) {
    const { items } = payload;
    // console.log(items, getters.userDetails.usr.user_id);

    const hiddenModules = await UserService.saveHiddenModule({
      items: JSON.stringify(items),
      // user_id: getters.userDetails.usr.user_id,
      user_id: user_idr(),
    });

    // commit(types.SelectedUser.SET.SINGLE, {
    //   ...getters.userDetails,
    //   userPerm: {
    //     blocked: {
    //       ...items.permission
    //     }
    //   }
    // })

    dispatch(types.UserDetails.UPDATE.MULTIPLE, {
      userPerm: {
        blocked: {
          ...items.permission
        }
      }
    });
  },
  async [types.UPDATE_USER_DETAILS]({ commit, getters, dispatch }, payload) {
    console.log(payload);
    const { name, value } = payload;

    // commit(types.SelectedUser.SET.SINGLE, {
    //   ...getters.userDetails,
    //   [name]: value
    // });

    dispatch(types.UserDetails.UPDATE.MULTIPLE, {
      [name]: value
    });
  },

  async [types.DELETE_HIDDEN_INVOICE_PROJECT]({ commit, getters, dispatch }, payload) {
    const { user_id, invoice_project_id } = payload;
    // commit(types.SelectedUser.SET.SINGLE, {
    //   ...getters.userDetails,
    //   invoice_projects: getters.userDetails.invoice_projects.filter(ip => ip.invoice_project_id != invoice_project_id),
    // });

    const selectedUser = getters.userDetails[user_idr()];
    const invoice_projects = selectedUser.invoice_projects.filter(ip => ip.invoice_project_id != invoice_project_id);
    dispatch(types.UserDetails.UPDATE.MULTIPLE, {
      invoice_projects
    });

    const unhiddenInvoiceProject = await UserService.unhideInvoiceProject({
      invoice_project_id,
      user_id
    });
  },
  async [types.DELETE_HIDDEN_ARTISTS_FEES]({ commit, getters, dispatch }, payload) {
    const { user_id, artist_id } = payload;

    // commit(types.SelectedUser.SET.SINGLE, {
    //   ...getters.userDetails,
    //   artists: getters.userDetails.artists.filter(ip => ip.artist_id != artist_id),
    // });

    const selectedUser = getters.userDetails[user_idr()];
    const artists = selectedUser.artists.filter(ip => ip.artist_id != artist_id);
    dispatch(types.UserDetails.UPDATE.MULTIPLE, {
      artists
    });

    const unHiddenArtistsFees = await UserService.unHideArtistsFees({
      artist_id,
      user_id
    });
  },
  async [types.Users.INSERT.SINGLE]({ commit, getters }, payload) {
    console.log(payload);

    const newUsers = await UserService.insertNewuser({
      ...payload
    });

    console.log(newUsers.data);
    commit(types.Users.SET.ALL, {
      ...getters.userlist,
      all_user: [
        ...newUsers.data.all_user
      ]
    });
  },

  async [types.Users.DELETE.SINGLE]({ commit, getters }, payload) {
    const user_id = payload;
    commit(types.Users.SET.ALL, {
      ...getters.userlist,
      all_user: getters.userlist.all_user.filter(user => user.user_id != user_id),
    });

    const deletedUser = await UserService.removeUser({
      user_id,
    });
  },

};